import { parseValue } from 'react-native-controlled-mentions';

import { MIN_SEARCH_CHARS } from '@src/constants/constants';
import { triggersConfigPlain } from '@utils/mentions';

// A link with a scheme (https://, ftp://, …), reduced to its host. Message
// search indexes the host ("google.com" finds a message linking
// https://google.com) but never the scheme: Postgres reads `https://` as a
// protocol token the `simple` config drops, while pg_search turns the term's
// `:` into a space and so requires a word `https` that isn't indexed. Path,
// port and query are dropped with it.
const LINK_PATTERN = /\b[a-z][a-z0-9+.-]*:\/\/([^\s/?#:,;)]+)\S*/gi;

// Only emoji or punctuation leaves the search query without a word to match.
const LETTER_OR_DIGIT = /[\p{L}\p{N}]/u;

/**
 * TA-11029: when a quoted-reply jump can't reach the original, the user is
 * offered chat search, prefilled with the original's text. The stored body
 * keeps mentions as markup, so it is reduced to the text the user sees (the
 * same reduction ChatsSearch uses for result previews), links are reduced to
 * their host, and line breaks and runs of whitespace are collapsed so it fits
 * the one-line search box. A term that couldn't find anything (too short to
 * search, or no letters or digits) is returned empty, so search just opens.
 */
export const replyJumpSearchTerm = (body?: string | null): string => {
  if (!body) return '';
  const { parts } = parseValue(body, [triggersConfigPlain.mention]);
  const term = parts
    .map((part) => part.text)
    .join('')
    .replace(LINK_PATTERN, ' $1 ')
    .replace(/\s+/g, ' ')
    .trim();
  if (term.length < MIN_SEARCH_CHARS || !LETTER_OR_DIGIT.test(term)) {
    return '';
  }
  return term;
};
